import * as actionTypes from '../actions/ActionTypes';
import Config from '../../utils/Configuration';

const initState = () => {
    if (sessionStorage.getItem(Config.sliceKey.order)) {
        return {...JSON.parse(sessionStorage.getItem(Config.sliceKey.order))};
    }
    return {};
};
const initialState = initState();

const getOrderSummaryFromApi = (state, payload) => {
    const orderSummary = {
        ...state,
        ...payload
    };
    sessionStorage.setItem(Config.sliceKey.order, JSON.stringify(orderSummary));
    return orderSummary;
};

const getOrderDetailFromApi = (state, payload) => {
    const orderSummary = {
        ...state,
        orderId: payload.orderId,
        orderSummary: {...payload}
    };
    sessionStorage.setItem(Config.sliceKey.order, JSON.stringify(orderSummary));
    return orderSummary;
};

const clearOrder = () => {
    const updatedState = {};
    sessionStorage.setItem(Config.sliceKey.order, JSON.stringify(updatedState));
    return updatedState;
};
const reducer = (state = initialState, action) => {
    const {payload = {}} = action;
    switch (action.type) {
        case actionTypes.GET_ORDER_SUMMARY:
            return getOrderSummaryFromApi(state, payload);
        case actionTypes.GET_ORDER_DETAILS:
            return getOrderDetailFromApi(state, payload);
        case actionTypes.CLEAR_ORDER:
            return clearOrder();
        default:
            return state;
    }
};

export default reducer;
